import { TypeCodeTranslation } from '../../../business/models/shared.model';
import { BusinessValidation } from '../../../business/models/policy-business.model';

export const enum DetailsHonoraryNoteActionTypes {
  FETCH_HONORARY_NOTES = '@@detailsHonoraryNote/FETCH_HONORARY_NOTES',
  FETCH_HONORARY_NOTES_SUCCESS = '@@detailsHonoraryNote/FETCH_HONORARY_NOTES_SUCCESS',
  FETCH_HONORARY_NOTES_FAIL = '@@detailsHonoraryNote/FETCH_HONORARY_NOTES_FAIL',
  FETCH_HONORARY_NOTE_TYPECODES = '@@detailsHonoraryNote/FETCH_HONORARY_NOTE_TYPECODES',
  FETCH_HONORARY_NOTE_TYPECODES_SUCCESS = '@@detailsHonoraryNote/FETCH_HONORARY_NOTE_TYPECODES_SUCCESS',
  FETCH_HONORARY_NOTE_TYPECODES_FAIL = '@@detailsHonoraryNote/FETCH_HONORARY_NOTE_TYPECODES_FAIL',
  NEW_HONORARY_NOTE = '@@detailsHonoraryNote/ADD_HONORARY_NOTE',
  SAVE_HONORARY_NOTE = '@@detailsHonoraryNote/SAVE_HONORARY_NOTE',
  SAVE_HONORARY_NOTE_SUCCESS = '@@detailsHonoraryNote/SAVE_HONORARY_NOTE_SUCCESS',
  SAVE_HONORARY_NOTE_FAIL = '@@detailsHonoraryNote/SAVE_HONORARY_NOTE_FAIL',
  ADD_HONORARY_NOTE_LINE = '@@detailsHonoraryNote/SAVE_HONORARY_NOTE_LINE',
  ADD_HONORARY_NOTE_LINE_SUCCESS = '@@detailsHonoraryNote/SAVE_HONORARY_NOTE_LINE_SUCCESS',
  ADD_HONORARY_NOTE_LINE_FAIL = '@@detailsHonoraryNote/SAVE_HONORARY_NOTE_LINE_FAIL',
  UPDATE_MESSAGE_DATE = '@@detailsHonoraryNote/UPDATE_MESSAGE_DATE',
  UPDATE_HONORARY_REFERENCE = '@@detailsHonoraryNote/UPDATE_HONORARY_REFERENCE',
  UPDATE_HONORARY_STRUCTURED_MESSAGE= '@@detailsHonoraryNote/UPDATE_HONORARY_STRUCTURED_MESSAGE',
  SELECT_HONORARY_NOTE = '@@detailsHonoraryNote/SELECT_HONORARY_NOTE',
  DELETE_HONORARY_NOTE = '@@detailsHonoraryNote/DELETE_HONORARY_NOTE',
  DELETE_HONORARY_NOTE_SUCCESS = '@@detailsHonoraryNote/DELETE_HONORARY_NOTE_SUCCESS',
  DELETE_HONORARY_NOTE_FAIL = '@@detailsHonoraryNote/DELETE_HONORARY_NOTE_FAIL',
  DELETE_HONORARY_NOTE_LINE = '@@detailsHonoraryNote/DELETE_HONORARY_NOTE_LINE',
  DELETE_HONORARY_NOTE_LINE_SUCCESS = '@@detailsHonoraryNote/DELETE_HONORARY_NOTE_LINE_SUCCESS',
  DELETE_HONORARY_NOTE_LINE_FAIL = '@@detailsHonoraryNote/DELETE_HONORARY_NOTE_LINE_FAIL',
  RESET_STATE = '@@detailsHonoraryNote/RESET_STATE',
}

export interface DetailsHonoraryNoteState {
  readonly selectedHonoraryNote: HonoraryNote;
  readonly honoraryNotes: HonoraryNote[];
  readonly lineTypeValues: TypeCodeTranslation[];
  readonly unitTypeValues: TypeCodeTranslation[];
  readonly vatPercentageValues: TypeCodeTranslation[];
  readonly validations: BusinessValidation[];
}

export interface HonoraryNote {
  readonly honoraryNoteId: number;
  readonly caseCode: string;
  readonly instructionId: number;
  readonly honoraryReference: string;
  readonly messageDate: string;
  readonly honoraryNoteLines: HonoraryNoteLine[];
  readonly createdOn: string;
  readonly createdByFirstName: string;
  readonly createdByLastName: string;
  readonly locked: boolean;
  readonly approved?: boolean;
  readonly structuredMessage: string;
}

export interface HonoraryNoteLine {
  readonly honoraryNoteLineId: number;
  readonly honoraryNoteId: number;
  readonly description: string;
  readonly lineTypeTC: string;
  readonly number: string;
  readonly unitTypeTC: string;
  readonly unitPrice: string;
  readonly vatPercentage: string;
}
